<template>
  <div :class="{ 'cardDamage': true, 'isSmall': small }">
    <div>
      <slot name="damage" />
      <template v-if="$slots.extraDamage">&nbsp;<small>(<slot name="extraDamage" />)</small></template>
    </div>
    <p v-if="$slots.damageType"><slot name="damageType" /> damage</p>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    small: {
      type: Boolean
    }
  }
})
</script>

<style lang="sass" scoped>
.cardDamage > div
  font-size: 240%
  font-family: 'Playfair Display', sans-serif
  font-weight: bold

.cardDamage.isSmall > div
  font-size: 180%

.cardDamage > p
  font-size: 120%

.cardDamage.isSmall > p
  font-size: 100%
</style>
